import cookies from "js-cookie";
import topDomain from "@segment/top-domain";

export const removeCookie = (cookieName) => {
  const domain = topDomain(window.location.href);
  const config = domain != undefined ? { domain } : undefined;
  cookies.remove(cookieName, config);
};

export const setCookie = (cookieName, value) => {
  const domain = topDomain(window.location.href);
  const config = domain != undefined ? { domain } : undefined;
  cookies.set(
    cookieName,
    typeof value === "string" ? value : JSON.stringify(value),
    config,
  );
};

export const getCookie = (cookieName) => {
  return cookies.get(cookieName);
};
